import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'truncateNum'})
export class TruncateNumPipe implements PipeTransform {

    constructor(private currencyPipe: CurrencyPipe) {}

    public transform(value: number): string {
        const numberTruncated = Math.trunc(value * 100) / 100;
        return this.currencyPipe.transform(numberTruncated, ' ', false);
    }

}
